import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { tierTableHeader } from 'app/constants/table-header-constants';
import useTierManagement from './useTierManagement';
import FilterModel from 'app/components/FilterModel';

const TierManagement = () => {
  const {
    isdeleteFiltering,
    totalNumber,
    sectionObj,
    filteredData,
    isFilterOpen,
    setIsFilterOpen,
    handleDelete,
    handleEdit,
    setValues,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    paginationHandler,
    navigate,
    resetfilter,
    onCancel,
    onSubmit,
    changeHandler,
    fetchTierData,
    isFiltering,
    values,
  } = useTierManagement();

  return (
    <>
      <div className='cms-content__container'>
        <>
          <PaginatedTable
            sectionObj={sectionObj}
            columns={tierTableHeader}
            data={filteredData}
            fulldata={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            totalNumber={totalNumber}
            pageCount={pageCount}
            paginationHandler={paginationHandler}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            fetchData={fetchTierData}
            changeHandler={changeHandler}
            pageLoading={pageLoading}
            navigate={navigate}
            isFiltering={isFiltering}
            values={values}
            isdeleteFiltering={isdeleteFiltering}
          />
        </>
      </div>
      {isFilterOpen && (
        <FilterModel
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          onSubmit={onSubmit}
          onCancel={onCancel}
          resetfilter={resetfilter}
        >
          <>
            <div className='offcanvas-item'>
              <label>Tier Name:</label>
              <input
                type='text'
                value={values?.tiername}
                onChange={(e) =>
                  setValues({ ...values, tiername: e.target.value })
                }
              />
            </div>
            <div className='offcanvas-item'>
              <label>Stat Date:</label>
              <input
                type='date'
                placeholder='Start Date'
                value={values?.startDate}
                max={values?.endDate}
                onChange={(e) =>
                  setValues({ ...values, startDate: e.target.value })
                }
              />
            </div>
            <div className='offcanvas-item'>
              <label>End Date:</label>
              <input
                type='date'
                placeholder='EndDate'
                value={values?.endDate}
                min={values?.startDate}
                onChange={(e) =>
                  setValues({ ...values, endDate: e.target.value })
                }
              />
            </div>
          </>
        </FilterModel>
      )}

      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default TierManagement;
